// Компонент числового поля ввода с tooltip

import type { NumberInputProps } from '../../types';
import { HelpCircle } from 'lucide-react';
import './Input.css';

interface ExtendedNumberInputProps extends NumberInputProps {
  tooltip?: string;
  required?: boolean;
  hint?: string;
  error?: string;
}

export function NumberInput({
  label,
  value,
  onChange,
  min,
  max,
  step = 1,
  unit,
  disabled = false,
  tooltip,
  required = false,
  hint,
  error,
}: ExtendedNumberInputProps) {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = parseFloat(e.target.value);
    if (!isNaN(newValue)) {
      onChange(newValue);
    }
  };

  return (
    <div className="input-group">
      <label className={`input-group__label ${required ? 'input-group__label--required' : ''}`}>
        {label}
        {tooltip && (
          <span className="tooltip input-group__tooltip">
            <HelpCircle className="tooltip__trigger" size={16} />
            <span className="tooltip__content">{tooltip}</span>
          </span>
        )}
      </label>
      <div className="input-group__wrapper">
        <input
          type="number"
          className={`input-group__field ${error ? 'input-group__field--error' : ''}`}
          value={value}
          onChange={handleChange}
          min={min}
          max={max}
          step={step}
          disabled={disabled}
          aria-describedby={hint ? `${label}-hint` : undefined}
          aria-invalid={!!error}
        />
        {unit && <span className="input-group__unit">{unit}</span>}
      </div>
      {hint && !error && (
        <span className="input-group__hint" id={`${label}-hint`}>{hint}</span>
      )}
      {error && (
        <span className="input-group__error" role="alert">{error}</span>
      )}
    </div>
  );
}
